import Alert from "@amzn/awsui-components-react/polaris/alert";
import { CreateOrderResponse } from "../../Types/CreateOrder";
import { CopyToClipboard } from "@amzn/awsui-components-react";

const CreateOrderPageResult = ({ response }: { response: CreateOrderResponse }) => {
  return (
    <Alert type="success">
      Order created successfully: {response.orderId}
      <CopyToClipboard
        variant="icon"
        textToCopy={response.orderId}
        copySuccessText="Copied!"
        copyErrorText="Try again!"
      />
    </Alert>
  );
};
export default CreateOrderPageResult;
